import { useEffect, useState } from "react";

export const useSearch = (data = [], keys = []) => {
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const onInputChange = (e) =>
    setFilteredData(
      data?.filter((record) => {
        return keys.find((key) =>
          record?.[key]?.toLowerCase()?.includes(e.target.value?.toLowerCase())
        );
      })
    );

  return { filteredData, onInputChange };
};
